export type SlaBadgeTone = 'overdue' | 'soon' | 'ok' | 'none'

export function getSlaBadgeTone(
  slaDueAt: string | null | undefined,
  status: string,
  now = new Date(),
): SlaBadgeTone {
  if (!slaDueAt) return 'none'
  if (status === 'CONCLUIDO' || status === 'CANCELADO' || status === 'CONTRATO_ASSINADO' || status === 'PAUSADO') {
    return 'none'
  }

  const due = new Date(slaDueAt)
  if (due.getTime() < now.getTime()) return 'overdue'

  const in24h = new Date(now.getTime() + 24 * 60 * 60 * 1000)
  if (due.getTime() <= in24h.getTime()) return 'soon'

  return 'ok'
}

export const SLA_BADGE_CLASS: Record<SlaBadgeTone, string> = {
  overdue: 'bg-red-100 text-red-800',
  soon: 'bg-amber-100 text-amber-800',
  ok: 'bg-emerald-100 text-emerald-800',
  none: 'text-text-muted',
}

export function formatSlaLabel(slaDueAt: string | null | undefined, tone: SlaBadgeTone): string {
  if (!slaDueAt) return '—'
  const formatted = new Date(slaDueAt).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
  if (tone === 'overdue') return `${formatted} (vencido)`
  if (tone === 'soon') return `${formatted} (vence em breve)`
  return formatted
}
